import type { FaireProductEntity } from "../../entity_types/product";

export const p_8h42jj4dxe: FaireProductEntity = {
  token: "p_8h42jj4dxe",
  type: "product",
  name: "NEW Non Melatonin-Slumber Shots Sleep Aid | 12-Pack",
  brandToken: "b_b8u198pwlc",
  brandName: "Seattle Gummy Company",
  imageUrl:
    "https://cdn.faire.com/fastly/735f2690eb9ef684b4932a92f201a2ad4dd593490475902d88caa44642665c6c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7ed8e4ff699245fe82c2116067cc564bc97527a14a7ca823ef308390040a99f4.png",
    "https://cdn.faire.com/fastly/efd4b50af5b856bc0b378fa6cf66c159969591a6c35e036e9c42370f268c8c13.png",
    "https://cdn.faire.com/fastly/0e81cefb94b1ed2d1a1e3eff6c65c9c09b7e36422081aadce91062186354188a.png",
    "https://cdn.faire.com/fastly/e9639bf24c7110b438c2d0bec990f6429190f0a11d7acb93f8cf0963d7b2e214.jpeg",
    "https://cdn.faire.com/fastly/2ca6c327ca273940bf77b3b4b12e2e7ca9dbf53e2c5f2d3c62ef3efdc94ea4c7.png",
  ],
  priceDollars: 22.44,
  description:
    "HERBAL BLEND SUPPORTS A GOOD NIGHT’S SLEEP\n\nPacked with sleep-promoting compounds, this sugar-free gummy combines with two prized medicinal herbs: valerian root and wild jujube – known to promote calmness, reduce anxiety, and improve sleep quality. This super herb combination contains the highest concentration of sleep-promoting compounds in a gummy and helps build a healthy sleep cycle that supports a goodnight’s sleep.",
  tags: [],
  msrpDollars: 44.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:45.879Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
